import DataChart from './DataChart'

export default DataChart
